module.exports = __webpack_public_path__ + "img/ico-activity.73f94a5f.svg";